import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import Skeleton from "common/components/ui/Skeleton";

import LeadsListItem from "./LeadsListItem";

import type { NavigatorLead } from "../../../../../types";

import LeadsImage from "assets/images/empty-placeholders/no-profiles.png";

export default function LeadsList({
  leads,
  isLoading,
  pageSize,
}: {
  leads: NavigatorLead[];
  isLoading: boolean;
  pageSize: number;
}) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-3">
        {new Array(pageSize).fill(undefined).map((_, index) => (
          <div
            className="flex items-center gap-x-2 rounded-3xl border border-black-200 p-3"
            // biome-ignore lint/suspicious/noArrayIndexKey: no unique key
            key={index}
          >
            <Skeleton className="size-10 rounded-2xl" />
            <div className="flex flex-1 flex-col gap-y-0.5">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-4 w-20" />
            </div>
            <Skeleton className="size-5" />
          </div>
        ))}
      </div>
    );
  }
  if (leads?.length) {
    return (
      <div className="grid grid-cols-2 gap-3">
        {leads.map((lead) => (
          <LeadsListItem key={lead.id} lead={lead} />
        ))}
      </div>
    );
  }
  return (
    <EmptyPlaceholder
      title="Apply filters to find leads"
      subtitle="Leads matching your search criteria will be displayed here"
      imageSrc={LeadsImage}
      className="py-20"
    />
  );
}
